import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import GLightbox from "glightbox";

import "swiper/css";
import "glightbox/dist/css/glightbox.css";

const Gallery = ({
  heading,
  description,
  images,
  showCaption = false
}) => {

  useEffect(() => {
  const lightbox = GLightbox({
    selector: ".our-gallery-lightbox",
    touchNavigation: true,
    loop: true,
    openEffect: "zoom",
    closeEffect: "fade"
  });

  return () => {
    lightbox.destroy();
  };
}, []);

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 35,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="our-gallery-section">

 
{(heading || description) && (
  <motion.div
    className="our-gallery-top"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeUp}
  >

    {heading && (
      <motion.h2
        className="section-heading"
        variants={fadeUp}
      >
        {heading}
      </motion.h2>
    )}

    {description && (
      <motion.p
        className="section-text"
        variants={fadeUp}
      >
        {description}
      </motion.p>
    )}

  </motion.div>
)}



      {/* SLIDER */}
      <div className="our-gallery-slider">

        <Swiper
          modules={[Autoplay]}
          slidesPerView={4}
          spaceBetween={20}
          loop={true}
          speed={8000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false
          }}
          breakpoints={{
            0: {
              slidesPerView: 1
            },
            576: {
              slidesPerView: 1
            },
            768: {
              slidesPerView: 2
            },
             992: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          }}
          className="our-gallery-swiper"
        >

         {images.map((item, index) => (
  <SwiperSlide key={index}>
    <motion.div
      className="our-gallery-card"
      initial={{
        opacity: 0,
        y: 80,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: false,
        amount: 0.4,
      }}
      transition={{
        duration: 0.7,
        delay: index * 0.08, 
        ease: "easeOut",
      }}
      whileHover={{
        y: -8,
        transition: {
          duration: 0.25,
        },
      }}
    >
      <a
        href={item.image}
        className="our-gallery-lightbox"
      >
        <motion.img
          src={item.image}
          alt={
            heading
              ? `${heading} ${index + 1} | Iris Impulse India Pvt. Ltd.`
              : `Trade Participation & Honours ${index + 1} | Iris Impulse India Pvt. Ltd.`
          }
          className="our-gallery-image"
          whileHover={{
            scale: 1.1,
          }}
          transition={{
            duration: 0.35,
          }}
        />
      </a>

      {showCaption && item.title && (
        <motion.div
          className="our-gallery-caption"
          initial={{
            opacity: 0,
            y: 15,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: false,
          }}
          transition={{
            delay: index * 0.08 + 0.2,
            duration: 0.45,
          }}
        >
          <p className="section-text">
            {item.title}
          </p>
        </motion.div>
      )}
    </motion.div>
  </SwiperSlide>
))}
        </Swiper>

      </div>

    </section>
  );
};

export default Gallery;